<template>
  <div class="warp">
    <!-- 热点新闻 -->
    <div class="news">
      <!-- <div class="img" :style="{ backgroundImage: `url(${imgUrl})` }" @click="goDetail()"></div> -->
      <div style="width:100%">
        <!-- 轮播图 -->
        <div>
          <div class="img">
            <el-carousel>
              <el-carousel-item v-for="item in hotImageList" :key="item">
                <div style="position: relative;">
                  <div class="img" :style="{ backgroundImage: `url(${item.cover})` }" @click="goInfo(item.id)"></div>
                  <div class="imgBack">
                      {{item.title}}
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>

        <!-- 下方新闻 -->
        <div style="width: 372px;margin-top: 12px;height:330px;">
           <el-tabs v-model="leftActiveName" type="card" @tab-click="leftHandleClick">
            <el-tab-pane label="企业动态" name="first">
              <ul class="ulClass">
                <li
                  v-for="(item, index) in list1"
                  :key="index"
                >
                  <p v-if="index === 0" class="news_title_first" @click="goInfo(item.id)">{{ item.title }}</p>
                   <p v-else class="news_title" @click="goInfo(item.id)">{{ item.title }}</p>
                </li>
              </ul>
            </el-tab-pane>
            <!-- <el-tab-pane label="会员风采" name="second">
              <ul class="ulClass">
                <li
                  v-for="(item, index) in list1"
                  :key="index"
                >
                  <p v-if="index === 0" class="news_title_first" @click="goInfo(item.id)">{{ item.title }}</p>
                   <p v-else class="news_title" @click="goInfo(item.id)">{{ item.title }}</p>
                </li>
              </ul>
            </el-tab-pane> -->
          </el-tabs>
        </div>
      </div>
      <div class="news_hot">
        <hotNews
          title="换一批"
          :list="hotIndustryinfoList"
          @dataRefresh="getRandomList(12)"
          @sendImgUrl="getImgUrl"
        ></hotNews>
      </div>
      <div class="needs_newest" >
        <ul class="operation" v-if="!userinfo">
          <li>
            <router-link target="li" to="/register">注册</router-link>
          </li>
          <li>
            <router-link target="li" to="/login">登录</router-link>
          </li>
        </ul>
        <ul
          class="needs_add"
          :style="userinfo ? { borderTop: '1px solid #eee'} : ''"
        >
          <li @click="goToUrl('/demand')">发布需求信息</li>
          <li  @click="goSupply()">发布供应信息</li>
        </ul>
         <p class="needs_newest_tips">
           <span itemid="" @click="moreTo()">最新需求</span>
           <span @click="moreTo()">更多>></span>
           </p>
           <marquee :send-val='demandList'  :v-if='demandList' :style="userinfo ? { height: '150px'} : ''"></marquee>

        <!-- 登录下方新闻模块 -->
        <div style="width: 244px;height: 50px;margin-top: 10px;height:330px;">
          <el-tabs v-model="rightActiveName" type="card" @tab-click="rightHandleClick">
            <el-tab-pane label="环学院" name="first">
              <ul class="ulClass">
                <li
                  v-for="(item, index) in list2"
                  :key="index"
                >
                  <!-- <p class="news_title">{{ item.title }}</p> -->
                  <p v-if="index === 0" class="news_title_first" @click="toDetailNewpage('/environmental_college_detail', item.id)">{{ item.title }}</p>
                   <p v-else class="news_title" @click="toDetailNewpage('/environmental_college_detail', item.id)">{{ item.title }}</p>
                </li>
              </ul>
            </el-tab-pane>
            <el-tab-pane label="别样环保人" name="second">
              <ul class="ulClass">
                <li
                  v-for="(item, index) in list2"
                  :key="index"
                >
                  <!-- <p class="news_title">{{ item.title }}</p> -->
                  <p v-if="index === 0" class="news_title_first" @click="goInfo(item.id)">{{ item.title }}</p>
                   <p v-else class="news_title" @click="goInfo(item.id)">{{ item.title }}</p>
                </li>
              </ul>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>

    <!-- 双十一临时活动 -->
    <!-- <div class="activeLs" @click="toDoubleEleven"> -->
      <!-- <div class="left">
        <p>{{activity.title }}</p>
      </div>
      <div class="right">
        <div class="ctx" v-html="$options.filters.ellipsis(activity.subject) "></div>
        <button @click="toDetailNewpage('/activity_detail', activity.id)"
        >了解更多</button>
      </div> -->
    <!-- </div> -->

    <!-- 环保管家服务 -->
    <div class="butler_service">
      <h2>环保管家服务</h2>
      <ul class="content_1">
        <li @click="goToUrl('/environmental_housekeeper?id=section1')">
          <img src="../assets/images/icon_1.png" alt="" />
          <p>环保服务</p>
          <p>Trusteeship Operation</p>
        </li>
        <li @click="goToUrl('/environmental_housekeeper?id=section2')">
          <img src="../assets/images/icon_2.png" alt="" />
          <p>环保工程</p>
          <p>EIA Report</p>
        </li>
        <li @click="goToUrl('/environmental_housekeeper?id=section3')">
          <img src="../assets/images/icon_3.png" alt="" />
          <p>环保咨询</p>
          <p>Engineering Design</p>
        </li>
        <li @click="goToUrl('/environmental_housekeeper?id=section4')">
          <img src="../assets/images/icon_4.png" alt="" />
          <p>绿色金融服务</p>
          <p>Green Financial Services</p>
        </li>
        <li @click="goToUrl('/environmental_housekeeper?id=section6')">
          <img src="../assets/images/icon_5.png" alt="" />
          <p>环保产品集采</p>
          <p>Product collection</p>
        </li>
        <li @click="goToUrl('/environmental_housekeeper?id=section7')">
          <img src="../assets/images/icon_6.png" alt="" />
          <p>环保人才</p>
          <p>Environmental Protection Talents</p>
        </li>
        <li @click="goToUrl('/environmental_housekeeper?id=section5')">
          <img src="../assets/images/icon_7.png" alt="" />
          <p>环保培训</p>
          <p>Environmental protection training</p>
        </li>
      </ul>
	  <!--广告-->
      <advertisement
        v-if="advList.length > 0"
        :list="advList.slice(0, 2)"
      ></advertisement>
      <ul class="content_3" v-if="advList.length > 0">
        <li v-for="(item, index) in advList.slice(2)" :key="index">
          <a :href="'//' + item.url" target="_blank"
            ><img :src="item.image" alt=""
          /></a>
        </li>
      </ul>
	  <!--侧边广告-->
      <div class="advertising_space">
        <!-- <a :href="'//'+ adv_port.url" target="_blank">
          <img :src="adv_port.image"  alt=""/>
        </a> -->
      <!-- <div class="space_code">
        <img :src="Qrcode.content" />
        <p>{{Qrcode.name}}</p>
      </div> -->
       <div class="space_code" v-for="(item,index) in QrcodeList" :key="index">
        <img :src="item.content" />
        <p>{{item.name}}</p>
      </div>

      </div>
    </div>
    <!-- 世界水日峰会 -->
    <!-- <div class="water_meeting" v-if="!activeStatus">
      <div class="left">
        <p>{{activity.title }}</p>
      </div>
      <div class="right">
        <div class="ctx" v-html="$options.filters.ellipsis(activity.subject) "></div>
        <button @click="toDetailNewpage('/activity_detail', activity.id)"
        >了解更多</button>
      </div>
    </div> -->

    <!-- 专访视频 -->
  <div class="exclusive_interview" v-show="exclusiveInterviewCourseList.length != 0">
    <div class="curriculum">
        <div class="curriculum_meun">
          <ul>
            <li
              :class="{ active: current == item.value }"
              v-for="(item, index) in exclusiveInterviewList"
              :key="index"
            >
              {{ item.name }}
            </li>
          </ul>
          <span @click="refreshData" class="false">换一批</span>
        </div>
        <ul class="curriculum_list">
          <li
            v-for="(item, index) in exclusiveInterviewCourseList"
            :key="index"
            :class="{active:isActive}"
             @click="toDetailNewpage('/enterprise_interview_detail', item.id)"
          >
            <div class="img">
                <img :src="item.cover" alt="" />
              </div>
              <div class="model"></div>
              <p class="curriculum_title" v-if="item.title">{{ item.title}}</p>
            <!-- <span class="curriculum_time">{{
              item.createtime && item.createtime.substring(0, 10)
            }}</span> -->
          </li>
        </ul>
        <ul class="curriculum_list">
          <li
            v-for="(item, index) in courseLists"
            :key="index"
            :class="{active:isActive}"
            @click="toDetailNewpage('/curriculumDetail', item.id)"
          > <div class="courseList">
            <img src="../assets/images/download_1.jpg" alt="">
            <div class="courseList_box">
              <p class="couers_title" v-if="item.title">{{ item.title }}</p>
              <span>{{
              item.createtime && item.createtime.substring(0, 10)
            }}</span>
            </div>
          </div>
          </li>
        </ul>
      </div>
  </div>
    <!-- 课程/视频  专家列表-->
    <div class="info_content">
      <div class="curriculum">
        <div class="curriculum_meun">
          <ul>
            <li
              @click="courseTypeChange(item),Changes(index)"
              :class="{ active: current == item.value }"
              v-for="(item, index) in courseTypeList"
              :key="index"
            >
              {{ item.name }}
            </li>
          </ul>
          <span @click="moreCourses">更多 ></span>
        </div>
        <ul class="curriculum_list">
          <li
            v-for="(item, index) in courseList"
            :key="index"
            :class="{active:isActive}"
             @click="toDetailNewpage('/environmental_college_detail', item.id)"
          >
            <div class="img">
                <img :src="item.cover" alt="" />
              </div>
              <div class="model"></div>
              <p class="curriculum_title" v-if="item.title">{{ item.title}}</p>
            <!-- <span class="curriculum_time">{{
              item.createtime && item.createtime.substring(0, 10)
            }}</span> -->
          </li>
        </ul>
        <ul class="curriculum_list">
          <li
            v-for="(item, index) in courseLists"
            :key="index"
            :class="{active:isActive}"
            @click="toDetailNewpage('/curriculumDetail', item.id)"
          > <div class="courseList">
            <img src="../assets/images/download_1.jpg" alt="">
            <div class="courseList_box">
              <p class="couers_title" v-if="item.title">{{ item.title }}</p>
              <span>{{
              item.createtime && item.createtime.substring(0, 10)
            }}</span>
            </div>
          </div>
          </li>
        </ul>
      </div>
      <div class="expert">
        <div class="export_meun">
          <p>环保达人</p>
          <span @click="toDetailNewpage('/expert_list')">更多 ></span>
        </div>
        <div class="button-prev" @click="swiperChange('prev')">
          <img src="../assets/images/up.jpg" alt="" />
        </div>
        <div v-swiper:mySwiper="swiperOption" v-if="expertList.length > 0">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide box"
              @click="toDetailNewpage('/expert_detail', item.userId)"
              v-for="(item, index) in expertList"
              :key="index"
            >
              <div class="swiper_bater">
                  <img :src="item.headUrl" alt="" />
              </div>
              <div class="export_desc">
                <p>{{ item.name }}</p>
                <div>{{item.expertDes}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="button-next" @click="swiperChange('next')">
          <img src="../assets/images/down.jpg" alt="" />
        </div>
      </div>
    </div>
    <!-- 资料库 -->
    <div class="database">
      <div class="database_nav">
        <span>资料库</span>
        <ul>
          <li
            :class="{ active: currentDatabaseType.id == item.id }"
            v-for="(item, index) in industryList"
            :key="index"
            @click="databaseTypeChange(item)"
            @mouseenter="mouseover(item)"
            @mouseleave="mouseLeave(item)"
          >
            <!-- v-show="industryList_detection(item.id)" -->
            {{ item.name }}
          </li>
        </ul>
        <span @click="toDetailNewpage('/data_center')">更多 ></span>
      </div>
      <div class="database_list">
        <ul v-for="(item, index) in databaseList.slice(0,15)" :key="index">
          <li
            @click="toDetailNewpage('/data_detail', inner.id)"
            v-for="(inner, innerIndex) in item"
            :key="innerIndex"
            class="active"
          >
            <p v-if="inner.title">{{ inner.title }}</p>
            <span>
              {{ inner.createtime && inner.createtime.substring(0, 10) }}
            </span>
          </li>
        </ul>
      </div>
    </div>
    <!-- 行业名企榜 -->
    <div class="enterprises_list">
      <p>行业名企榜</p>
      <swiperList
        v-if="companyList.length > 0"
        :list="companyList"
        @onParant="goParant"
      ></swiperList>

    </div>
    <!-- 产品推荐 -->
    <div class="product_recommendation">
      <p class="product_tips">产品推荐</p>
      <ul>
        <li
          v-for="(item, index) in productList"
          :key="index"
          @click="toDetailNewpage('/supply_detail', item.id)"
        >
          <div class="img">
            <img :src="item.cover" alt="" />
          </div>
          <div class="product_info">
            <div class="product_message">
              <p v-if="item.title">{{ item.title }}</p>
              <span>{{ item.companyname }}</span>
            </div>
            <div class="product_price">￥{{ item.price }}</div>
          </div>
        </li>
      </ul>
    </div>
    <!-- 供应信息/环保需求 -->
    <div class="info_needs">
      <div class="supply_info">
        <p class="supply_tips">
          <span>供应信息</span>
          <span @click="Gomore()">更多>></span>
          </p>
          <!--服务推荐-->
        <div class="supply_list">
          <ul v-for="(item, index) in serviceList" :key="index">
            <li
              v-for="(inner, innerIndex) in item"
              :key="innerIndex"
              @click="toDetailNewpage('/supply_detail', inner.id)"
            >
              <p v-if="inner.title">{{ inner.title }}</p>
              <span> {{ inner.createtime && inner.createtime.substring(0, 10)  }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="environment_nedds">
        <p class="environment_tips">
          <span>环保需求</span>
          <span @click="moreTo()">更多>></span>
          </p>
        <div class="environment_list">
          <ul>
            <li
              @click="toDetailNewpage('/demand_detail', item.id)"
              v-for="(item, index) in demandList"
              :key="index"
            >
              <p v-if="item.title">{{ item.title }}</p>
              <span> {{ parseTime(item.createDate, "{y}.{m}.{d}") }} </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 环保展会信息 -->
    <exhibitionInformation :list="activityList"  @onParants="goParants" ></exhibitionInformation>
  </div>
</template>

<script>
import { getRandomArray,routerGoNewpage } from "../utils/index";
import {
  getIndustryinfoList,
  getCompanyList,
  getProduct,
  getExpertList,
  getDataList,
  getLessonList,
  getDemandList,
  getDemandRecruitList,
  getActivityList,
  getAdv,
  getUserInfo,
  getInterviewList,
} from "../api/information";
import {getQr,getcrtinfolist} from "@/api/coment"
import hotNews from "../common/hotNews";
import exhibitionInformation from "../common/exhibitionInformation";
import advertisement from "../components/advertisement";
import swiperList from "../components/swiperList";
import marquee from "../components/marquee"
import { parseTime } from "@/utils";
import { frontBrowseSave } from "../api/coment";
export default {
  name: "marquee-up",
  components: {
    hotNews,
    exhibitionInformation,
    advertisement,
    swiperList,
    marquee,
  },
  data() {
    return {
      courseTypeList: [
        {
          name: "视频课程",
          value: 0,
        },
        {
          name: "课程资料",
          value: 1,
        },
      ],
      exclusiveInterviewList: [
        {
          name: "企业专访",
          value: 0,
        },
      ],
      isActive:false,
      current: 0,
      swiperOption: {
        slidesPerView: 3,
        slidesPerGroup: 1,
        direction: "vertical", //设置竖向轮播
      },
      swiperOptions: {
        slidesPerView: 6,
        slidesPerGroup: 1,
      },

      hotIndustryinfoList: [],
      list1: [],
      list2: [],
      imgUrl: "",
      id:'',
      companyList: [],
      productList: [],
      serviceList: [],  //服务
      expertList: [],
      listQuery:{
        curPage:1,
        limit:20
      },
      currentDatabaseType: "",
      databasePager: {
        curPage: 1,
        limit: 15,
      },
      databaseList: [],
      coursePager: {
        curPage: 1,
        limit: 6,
      },
      interViewPager: {
        curPage: 1,
        limit: 8,
        totalPage: 0,
      },
      dataQuery:{
        curPage: 1,
        limit: 12,
      },
      courseList: [],
      courseLists: [],
      demandPager: {
        curPage: 1,
        limit: 5,
      },
      expertQuery:{
        curPage: 1,
        limit: 9,
      },
      demandList: [],
      activityList: [],
      activeQuery:{
        curPage: 1,
        limit: 10,
      },
      advType: 2,
      advList: [],
      activity:{},
      animate:false,
      timer:null,
      testShow:false,
      total:0,
      totals:0,
      tober:0,
      Qrcode:{},
      Qrcode1: {},
      Qrcode2:{},
      QrcodeList:[],
      adv_port:{},
      hotImageList: [],
      activeName: 'first',
      rightActiveName: "first",
      leftActiveName: "first",
      exclusiveInterviewCourseList:[],  // 企业专访视频
    };
  },
  mounted() {
  },
  created() {
    // console.log("执行created")
    this.getHotIndustryinfoList(); // 新闻
    this.getActivityList(); // 活动
		this.getActivityLists();// 展会
    this.getCompanyList(); // 企业
    this.getProduct(); //产品
    this.getExpertList(); // 专家
    this.getRecommenedLesson(); // 课程
    this.getDemandList(); //需求
    this.getService(); //服务
    this.getAdv(); //广告
		this.getCode();
    this.getLeftList(); // 企业动态
    this.getRandomImageList();  // 轮播图
    this.getEnterpriceInterviewList();  //企业采访
    // // this.openVoice();
  },
  computed: {
    userinfo() {
      return this.$store.state.user.userInfo;
    },
    industryList() {
      let list =
        this.$store.getters.industry.length > 0 &&
        this.$store.getters.industry[0].children;
        this.currentDatabaseType = list[0];
        // list.splice(5,4);
        //console.log(list)
        return list;
    },
  },
  watch: {
    currentDatabaseType(val) {
      if (val && val.id) {
        this.getDataList();
      }
    }
  },
  filters:{
     ellipsis(value) {
      if (!value) return "";
      if (value.length > 150) {
        return value.slice(0, 150) + "...";
      }
      return value;
    }
  },
  methods: {
    industryList_detection(id){
      var arr = [15,16,17,18]
      if (arr.indexOf(id) != -1){
        return false
      }else{
        return true
      }
    },
    // 左侧新闻点击标签
    leftHandleClick(tab, event){
      this.list1 = []
      var type
      if (tab.index == 0){
        type = 16   // 企业动态
      }else{
        type = 17   // 会员风采
      }
      getIndustryinfoList({
        hot: 1,
        curPage: 1,
        limit: 6,
        type: type
      }).then((res) => {
        console.log(res)
        if(res.code == 0){
          this.list1 = res.page.list;
        }
      }).catch((err) => {});
    },

    getLeftList(){
      getIndustryinfoList({
        hot: 1,
        curPage: 1,
        limit: 6,
        type: 16
      }).then((res) => {
        if(res.code == 0){
          this.list1 = res.page.list;
        }
      }).catch((err) => {});
    },

    // 右侧标签点击
    rightHandleClick(tab,event){
      this.list2 = []
      if(tab.index == 0){
        this.list2 = this.courseList
      }else{
         getIndustryinfoList({
            hot: 1,
            curPage: 1,
            limit: 6,
            type: 18      // 别样环保人
          }).then((res) => {
            if(res.code == 0){
              this.list2 = res.page.list;
              this.getMate();
            }
          }).catch((err) => {});
      }
    },
    // 跳转到双十一页面
    toDoubleEleven(){
      this.$router.push('/double_eleven')
    },
    parseTime() {
      return parseTime(...arguments);
    },
    goDetail(){
       routerGoNewpage('/info_detail',{id:this.id})
    },
    goInfo(id){
       routerGoNewpage('/info_detail',{id:id})
    },
    //获取广告
    getAdv() {
      getAdv({
        curPage: 1,
        limit: 20,
        type: this.advType,
      }).then((res) => {
		 if(res.code ==0){
      // console.log("获取广告")
      // console.log(res)
      res.page.list.forEach(item => {
        if(item.id != 28){
          this.advList.push(item);
        }else{
          this.adv_port = item;
        }
      });
		 }
      });
    },
	//获取二维码
	getCode(){
    var that = this
	 getQr().then((res)=>{
		if(res.code ==0){
      var lengthNum = res.page.length
		  // this.Qrcode = res.page[2];
      // this.Qrcode1 = res.page[3];
      // this.Qrcode2 = res.page[4];
      for (var i = 2; i <= lengthNum-1; i++) {
          this.QrcodeList.push(res.page[i])
          // console.log("循环："+i)
      }
		}
	 }).catch((err)=>{})
	},


	//获取最新活动
	getActivityLists() {
	  getActivityList({
	    recommend: 1,
	    type:0
	  }).then((res) => {
		 if(res.code == 0){
			this.activity = res.page.list[0];
		 }
	  });
	},

    //获取展会列表
    getActivityList() {
      getActivityList({
        recommend: 1,
        type:1,
        ...this.activeQuery
      }).then((res) => {
		  if(res.code == 0){
			this.tober = res.page.totalCount;
			this.activityList = this.activityList.concat(res.page.list);
		  }
      });
    },
    //获取需求列表
    // getDemandList() {
    //   getDemandList({
    //     ...this.demandPager,
    //     recommend: 1,
    //   }).then((res) => {
		//  if(res.code == 0){
		// 	this.demandList = res.data.list;
		// 	this.testShow = true;
    //   getDemandRecruitList({
    //       ...this.demandPager,
    //       recommend: 1,
    //     }).then((res) => {
    //     if(res.code == 0){
    //       for(var i in res.page.list){
    //         this.demandList.push(res.page.list[i])
    //       }
    //       // this.demandList.push(res.page.list);
    //       this.demandList.pop()
    //       this.testShow = true;
    //     }
    //   });
		//  }
    //   });
    // },

    getDemandList() {
      getDemandRecruitList({
        ...this.demandPager,
        recommend: 1,
      }).then((res) => {
		 if(res.code == 0){
			this.demandList = res.page.list;
			this.testShow = true;
      getDemandList({
          ...this.demandPager,
          recommend: 1,
        }).then((res) => {
        if(res.code == 0){
          for(var i in res.data.list){
            this.demandList.push(res.data.list[i])
          }
          // this.demandList.push(res.page.list);
          this.demandList.pop()
          this.testShow = true;
          // console.log("需求列表")
          // console.log(this.demandList)
        }
      });
		 }
      });
    },

    // 人力资源需求
    // getDemandRecruitList(){
    //   getDemandRecruitList({
    //     ...this.demandPager,
    //     recommend: 1,
    //   }).then((res) => {
		//  if(res.code == 0){
		// 	this.demandList = res.page.list;
		// 	this.testShow = true;
		//  }
    //   });
    // },

    //课程类型切换
    courseTypeChange(item) {
      this.current = item.value;
    },
    //获取课程
    getRecommenedLesson() {
      getLessonList({
        ...this.coursePager,
        recommend: 1,
        sourcetype:0,
      }).then((res) => {
		 if(res.code == 0){
			this.courseList = res.page.list;
      this.list2 = this.courseList;
		 }
      });
    },

    // 企业专访
    getEnterpriceInterviewList(){
      getInterviewList({
        ...this.interViewPager
      }).then((res) => {
        if (res.code == 0){
          this.exclusiveInterviewCourseList = res.page.list
          this.interViewPager.totalPage = res.page.totalPage
        }
      })
    },
    refreshData(){
      if (this.interViewPager.curPage == this.interViewPager.totalPage){
        this.interViewPager.curPage = 1
      }else{
        this.interViewPager.curPage++
      }
      this.getEnterpriceInterviewList()
    },

    //获取课件
    getRecommenedLessons() {
      getLessonList({
        ...this.dataQuery,
        recommend: 1,
        sourcetype: 1,
      }).then((res) => {
		 if(res.code == 0){
		   this.courseLists= res.page.list;
		 }
      }).catch((err)=>{});
    },
     //课程类型切换
    Changes(index){
      if(index == 1){
        this.isActive = true;
        this.getRecommenedLessons();
      }else {
        this.isActive = false;
        this.getRecommenedLesson();
      }
    },
    //更多
    moreCourses:function(){
      if(this.current == 0){  //视频
        this.toDetailNewpage('/environmental_college')
      }else{
        this.toDetailNewpage('/environmental_college?type='+this.current)
      }
    },

    //资料库类型切换
    databaseTypeChange(item) {
      this.currentDatabaseType = item;
    },
    //hover 移入移出
    mouseover(data){
      this.$nextTick(()=>{
        this.currentDatabaseType = data;
        this.$set(data,'show',true)
      });
    },
    mouseLeave(data){
      this.$set(data,'show',false);
    },

    //获取资料中心列表
    getDataList() {
      getDataList({
        ...this.databasePager,
        category: this.currentDatabaseType.id,
      }).then((res) => {
		 if(res.code == 0){
			let list = [];
			res.page.list.map((item, index) => {
			  let iIndex = Math.floor(index / 5);
			  !list[iIndex] && (list[iIndex] = []);
			  list[iIndex].push(item);
			});
			this.databaseList = list;
		 }
      });
    },
    //跳转详情
    toDetail(path, id) {
      this.$router.push({
        path: path,
        query: {
          id: id,
        },
      });
    },
    //跳转详情打开新窗口
    toDetailNewpage(path,id){
        routerGoNewpage(path,{id,id})
    },
    //需求更多
    moreTo(){
     routerGoNewpage('/summary_demand',{})
    },
    //供应信息更多
    Gomore(){
      routerGoNewpage('/supply_demand',{})
    },
    //获取推荐专家
    getExpertList() {
      getExpertList({
        ...this.expertQuery,
        weight: 0
      }).then((res) => {
		if(res.code == 0){
		  this.total = res.data.totalCount;
		  this.expertList = this.expertList.concat(res.data.list) ;
		}
      });
    },
    //获取推荐产品
    getProduct() {
      getProduct({
        curPage: 1,
        limit: 8,
        recommend: 1,
        supplyType: 0,
       }).then((res) => {
		if(res.code == 0){
		   this.productList = res.page.list;
		}
      });
    },
    //获取推荐服务
    getService() {
      getProduct({
        curPage: 1,
        limit: 8,
        recommend: 1,
        supplyType: 1,
      }).then((res) => {
		 if(res.code == 0){
		  let list = [];
		  res.page.list.map((item, index) => {
		   let iIndex = Math.floor(index / 5);
		   !list[iIndex] && (list[iIndex] = []);
		   list[iIndex].push(item);
		  });
		 this.serviceList = list;
		 }
      });
    },
    //获取企业列表
    getCompanyList() {
      getCompanyList({
        ...this.listQuery,
        weight: 0,
      }).then((res) => {
         if(res.code == 0){
           this.totals = res.data.totalCount;
           this.companyList = this.companyList.concat(res.data.list)  ;
         }
      });
    },
    //获取热点新闻  前端取随机3个展示
    getHotIndustryinfoList() {
      getIndustryinfoList({
        hot: 1,
        curPage: 1,
        limit: 14,
      })
        .then((res) => {
		  if(res.code == 0){
			this.allList = res.page.list;
			// this.getRandomList(3);
      this.getRandomList(14);
			// this.getMate(this.hotIndustryinfoList);
      this.getMate();
		  }
        })
        .catch((err) => {});
    },
    getRandomList(length) {
      this.hotIndustryinfoList = _.compact(
        getRandomArray(_.cloneDeep(this.allList), length)
      );

      this.imgUrl = this.hotIndustryinfoList[0].cover;
      this.id = this.hotIndustryinfoList[0].id;
    },

    getRandomImageList() {
      getIndustryinfoList({
        hot: 1,
        recommend: 1,
        curPage: 1,
        limit: 5,
      }).then((res) => {
        if(res.code == 0){
          this.hotImageList = res.page.list;
        }
      }).catch((err) => {});
    },
    getImgUrl(item) {
      this.imgUrl = item.cover;
      this.id = item.id;
    },
    //切换轮播图
    swiperChange(type) {
      switch (type) {
        case "prev":
          this.mySwiper.slidePrev();
          break;
        default:
          this.mySwiper.slideNext();
          if(this.mySwiper.slideNext() == false){
            this.expertQuery.curPage ++;
            if(this.total == this.expertList.length) return
            this.getExpertList();
          }
          break;
      }
    },
    goToUrl(url) {
      this.$router.push(url);
    },
    //发布供应信息
    goSupply(){
      //'/corporate_supply'
      if(this.$store.state.user.userInfo !=null){
        if(this.$store.state.user.userInfo.type ==3){
          this.$router.push('/corporate_supply');
        }else{
          this.$message({
            message:'企业用户才能发布供应哦',
            type:'info'
          })
        }
      }else{
         this.$router.push('/login')
      }
    },
    goParant(item){
      this.listQuery.curPage = item;
      if(this.totals == this.companyList.length) return;
      this.getCompanyList();
    },
    goParants(item){
       this.activeQuery.curPage = item;
       if(this.tober == this.activityList.length) return;
       this.getActivityList();
    },
    //seo
    // getMate(data){
    //   var metas = document.getElementsByTagName("meta");
    //   metas[0].name ="keyword"
    //   metas[0].content= data[0].seokeywords
    //   metas[1].name ="description"
    //   metas[1].content=data[0].seodescription
    //   document.getElementsByTagName("title")[0].innerText= this.$route.meta.title +'_智污邦环保服务平台';
    // },
    getMate(){
      var metas = document.getElementsByTagName("meta");
      metas[0].name ="keywords"
      metas[0].content= "水处理,环保供需,环保技术对接"
      metas[1].name ="description"
      metas[1].content="智污邦环保服务平台，环境领域专注于水处理行业，整合1000多家优质环保企业，10W+环保从业人员，供需对接解决环保问题，强力打造“互联网+环保”线上学习交流资源共享的平台"
      document.getElementsByTagName("title")[0].innerText= this.$route.meta.title +'_智污邦环保服务平台';
    },
  },
  destroyed(){
    clearInterval(this.timer)
  },
};
</script>

<style scoped lang="less">
.ctx /deep/iframe{
  display: none;
}

.marquee-wrap  {
  width: 100%;
  height: 90px;
  border-left: 1px solid #eeeeee;
  border-right: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;
  margin: 0 auto;
  overflow: hidden;
  .marquee-list {
    li {
      padding: 0px 10px;
      width: 100%;
      height: 100%;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      list-style: none;
      line-height: 30px;
      color: #000000;
      font-size: 14px;
      font-weight: 400;
      text-align: left;
      cursor: pointer;
    }&:hover{
      color: #ff8a02;
    }
  }
  .animate-up {
    transition: all 0.5s ease-in-out;
    transform: translateY(-40px);
  }
}
.advertising_space {
  position: fixed;
  width: 110px;
  height: 295px;
  right: 1%;
  top: 50%;
  z-index: 1000 !important;

  // margin-top: -55px;
  margin-top: -153px;
  // @media (min-width: 1600px) {
  //   right: -15%;
  // }
  a{
	display: block;
    height:170px;
	width: 100%;
	overflow: hidden;
	img {
	  width: 100%;
	  height: 100%;
		object-fit: cover;
	}
  }
  .space_code{
	width: 100%;
	height: 120px;
	background: #fff;
	overflow: hidden;
	border: 1px solid #a0a0a0;
	img{
	 width: 100%;
	 height: 100px;
	}
	p{
	 display: block;
	 font-size: 12px;
	 color: #333333;
	 margin-top: -3px;
	}
  }

}
.swiper-container {
  height: 360px;
  border-right: 1px solid #eeeeee;
  border-left: 1px solid #eeeeee;
  padding: 0 10px;
}

.news {
  margin-top: 30px;
  display: flex;
  .img {
    // width: 372px;
    height: 312px;
    background-size: cover;
    background-position: center;
  }

  .news_hot {
    width: 420px;
    margin: 0 20px;
  }

  .needs_newest {
    width: 248.64px;
    .operation {
      position: relative;
      line-height: 59px;
      background: url("../assets/images/news_bg_04.jpg") no-repeat center/cover;
      display: flex;
      justify-content: space-around;

      li {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        cursor: pointer;

        &:nth-of-type(1) {
          &::after {
            cursor: default;
            position: absolute;
            right: 50%;
            top: 25px;
            display: inline-block;
            content: "";
            width: 2px;
            height: 10px;
            background: #ffffff;
          }
        }
      }
    }

    .needs_add {
      text-align: center;
      padding: 16px 7px;
      border-left: 1px solid #eeeeee;
      border-right: 1px solid #eeeeee;

      li {
        cursor: pointer;
        border: 1px solid #eeeeee;
        border-radius: 5px;
        padding: 10px 40px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;

        &::after {
          display: inline-block;
          content: "";
          width: 16px;
          height: 16px;
          background: url("../assets/images/arr_ows.png") no-repeat;
          vertical-align: text-top;
          margin-left: 5px;
          margin-top: 3px;
        }

        &:nth-of-type(1) {
          margin-bottom: 5px;

          &::before {
            display: inline-block;
            content: "";
            width: 16px;
            height: 16px;
            background: url("../assets/images/demans.png") no-repeat;
            vertical-align: middle;
            margin-right: 5px;
          }
        }

        &:nth-of-type(2) {
          &::before {
            display: inline-block;
            content: "";
            width: 16px;
            height: 16px;
            background: url("../assets/images/supplys.png") no-repeat;
            vertical-align: initial;
            margin-right: 5px;
          }
        }
      }
    }

    .needs_newest_tips {
      border-left: 1px solid #eeeeee;
      border-right: 1px solid #eeeeee;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #000000;
      padding: 10px 15px;
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #eeeeee;
      span:hover{
        color: #ff8a02;
        cursor: pointer;
      }
    }
    .needs_newest_tips span:nth-child(2){
      font-size: 12px !important;
    }

    .needs_newest_list {
      border-left: 1px solid #eeeeee;
      border-right: 1px solid #eeeeee;
      border-bottom: 1px solid #eeeeee;
      overflow:hidden;
      height: 90px;
      li {
        margin-bottom: 5px;
        word-break: break-all;
        // color:#ff8a02;
        cursor: pointer;
        width: 100%;
        line-height: 31px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        list-style: none;
        text-align: left;
        a {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #000000;
          &:hover{
            color: #ff8a02;
          }
        }
        &:hover{
          color: #ff8a02;
        }
        &:last-of-type {
          margin-bottom: 0;
        }
      }
      .animate-up {
       transition: all 0.5s ease-in-out;
       transform: translateY(-40px);
     }
    }
  }
}

.butler_service {
  text-align: center;
  margin-bottom: 40px;
  position: relative;

  h2 {
    margin: 40px 0 20px;
  }

  .content_1 {
    display: flex;
    justify-content: space-between;

    li {
      cursor: pointer;
      // flex: 1;
      width: 175px;
      height: 165px;
      margin-right: 7px;
      padding-bottom: 10px;

      img {
        height: 40px;
        margin: 20px 0;
        transition: all 0.6s;
      }
      img:hover{
        transform: scale(1.4);
      }

      p {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
      }

      &:nth-of-type(1) {
        background: linear-gradient(153deg, #ffd101, #ff7602);
      }

      &:nth-of-type(2) {
        background: linear-gradient(153deg, #63a3ec, #5767e7);
      }

      &:nth-of-type(3) {
        background: linear-gradient(153deg, #54e6e1, #54aae6);
      }

      &:nth-of-type(4) {
        background: linear-gradient(153deg, #aadb3a, #4ca028);
      }

      &:nth-of-type(5) {
        background: linear-gradient(153deg, #bb8ffd, #c057e7);
      }

      &:nth-of-type(6) {
        background: linear-gradient(153deg, #f03255, #f26a94);
      }

      &:nth-of-type(7) {
        margin-right: 0;
        background: linear-gradient(153deg, #ffd101, #ff7602);
      }
    }
  }

  .content_3 {
    display: flex;
    justify-content: space-between;
    margin-top: 17px;

    li {
      cursor: pointer;
      width: 308px;
      height: 149px;
      margin-right: 17px;
      overflow: hidden;
      &:last-of-type {
        margin-right: 0;
      }

      img {
        width: 100%;
        height: 100%;
        transition: all 0.5s;
        &:hover {
          transform: scale(1.2);
        }
      }
    }
  }

  .advertisement_position {
    width: 130px;
    position: absolute;
    top: 0;
    right: -140px;

    div {
      border: 1px solid #a0a0a0;
      border-top: 0;
      margin-top: -5px;
      padding: 5px 0;

      span {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000014;
      }
    }
  }
}
.activeLs {
  width: 100%;
  // height: 258px;
  height: 300px;    // 双十一活动临时
  margin-top: 25px;   // 双十一活动临时
  // background: url("../assets/images/bg_7.jpg") no-repeat center/cover;
  // background: url("https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fpic.616pic.com%2Fbg_w1180%2F00%2F03%2F81%2FqmB43N3fUs.jpg&refer=http%3A%2F%2Fpic.616pic.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1669970305&t=8d886ad4d5a10753b311406da09b34f0") no-repeat center/cover;
  background: url("http://124.222.90.117:8080/directlink/1/11-11-11webout2.png") no-repeat center/cover;
  margin-bottom: 40px;  
  background-size: 100% 300px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  padding: 91px 110px 0;
}
.water_meeting {
  width: 100%;
  height: 258px;
  // height: 300px;    // 双十一活动临时
  // margin-top: 25px;   // 双十一活动临时
  background: url("../assets/images/bg_7.jpg") no-repeat center/cover;
  margin-bottom: 40px;  
  background-size: 100% 300px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  padding: 91px 110px 0;
  .left{
    width: 254px;
    p {
      font-size: 36px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      overflow: hidden;
	  text-overflow: ellipsis;
      margin-bottom: 20px;
	  line-clamp: 2;
	  display: -webkit-box;
	  -webkit-line-clamp: 2;
	  -webkit-box-orient: vertical;
	  width: 100%;
    }
  }
  .right{
    padding-left: 10px;
     position: relative;
    // height:100px;
    .ctx{
      width: 547px;
      height: 39px;
      color: #fff;
      font-size: 14px;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
      margin-left: 30px;
	  text-overflow: ellipsis;
	  p{
		  &:nth-child(1){
			  overflow: hidden;
			  display: -webkit-box;
			  -webkit-line-clamp: 2;
			  line-clamp: 2;
			  -webkit-box-orient: vertical;
			  margin-left: 30px;
			  text-overflow: ellipsis;
		  }
    }
    }
     button {
      margin-left: 30px;
      margin-top: 6px;
      font-size: 15px;
      font-family: Arial;
      font-weight: 400;
      color: #ffffff;
      display: block;
      width: 112px;
      height: 30px;
      border: 1px solid #ffff;
      border-radius: 30px;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
       background: transparent;
       transition: all 0.3s;
       &:hover{
         background: #fff;
         color: #ff8a02;
       }

     }
  }:before{
     content: '';
     width: 1px;
     height: 78px;
     display: inline-block;
     position: absolute;
     background: rgba(255,255,255,0.9);
     left: 0px;
     top: 0;
  }

}


.info_content {
  display: flex;

  .curriculum {
    flex: 7;
    height: 458px;
    .curriculum_meun {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-right: 29px;
      ul {
        display: flex;
        margin-bottom: 10px;

        li {
          cursor: pointer;
          padding: 10px 0;
          color: #b8b8b8;
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: bold;

          &:nth-of-type(1) {
            margin-right: 20px;
          }
        }

        .active {
          position: relative;
          color: #343434;

          &::after {
            position: absolute;
            bottom: 0;
            left: 0;
            display: inline-block;
            content: "";
            width: 100%;
            height: 4px;
            background: #ff7402;
          }
        }
      }

      span {
        cursor: pointer;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #9a9a9a;
      }
    }

    .curriculum_list {
      display: flex;
      flex-wrap: wrap;

      li{
        // flex: 1;
        position: relative;
        cursor: pointer;
        width: 31%;
        margin-right: 12px;
        margin-bottom: 20px;
        span{
          color: rgba(153, 153, 153, 1);
        }
        &:nth-of-type(3n) {
          margin-right: 0;
        }
        .courseList{
          display: none;
        }
        &.active{
          margin-top: -14px;
          .img{
            display: none;
          }
          .model{
            display: none;
          }
          .curriculum_title{
            display: none;
          }
          .curriculum_time{
            display: none;
          }
          .courseList{
            width: 100%;
            display: block;
            height: 98px;
            padding: 25px 15px;
            border: 1px solid rgba(238, 238, 238, 1);
            img{
              width: 37px;
              height: 45px;
              display: block;
              float: left;
            }
            .courseList_box{
              width: 135px;
              overflow: hidden;
              float: right;
              height: 55px;
              p{
                font-size: 14px;
                height:38px;
                overflow: hidden;
                display:-webkit-box;
                -webkit-box-orient:vertical;
                -webkit-line-clamp:2;
              }
            }
          }
        }
        .img {
          width: 100%;
          height: 171px;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
            transition: all 0.5s;
            &:hover {
              transform: scale(1.2);
            }
          }
        }

        .model {
          position: absolute;
          width: 50px;
          height: 50px;
          background: url("../assets/images/play.png") no-repeat center/100%;
          top: 25%;
          right: 40%;
        }
        .curriculum_title {
          margin: 5px 0;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #343434;

          // 单行溢出省略
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .curriculum_time {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #9a9a9a;
        }
      }
    }
  }

  .expert {
    flex: 3;
    //  width: 27%;
    .export_meun {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 0;
      margin-bottom: 10px;

      p {
        color: #343434;
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: bold;

        &::before {
          display: inline-block;
          width: 5px;
          height: 23px;
          content: "";
          background: #ff7402;
          vertical-align: middle;
          margin-right: 5px;
        }
      }

      span {
        cursor: pointer;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #9a9a9a;
      }
    }

    .button-prev,
    .button-next {
      width: 100%;
      line-height: 20px;
      text-align: center;
      background: linear-gradient(-79deg, #ff7602, #ffc602);
      cursor: pointer;
    }

    .swiper-wrapper {
      .box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        img {
          // height: 80px;
          width: 100%;
        }

        .export_desc {
          margin-left: 10px;
          width: 100%;
          p {
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333;
            margin-bottom: 5px;
          }
          div{
            font-size: 14px;
            color: #999;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
			width: 98%;
			text-overflow: ellipsis;
          }
        }
      }
    }
  }
}


.exclusive_interview {
  display: flex;
  // margin-bottom: 7%;
  margin-bottom: 2%;

  .curriculum {
    flex: 7;
    // height: 458px;
    max-height: 458px;
    margin-bottom: 30px;
    .curriculum_meun {
      display: flex;
      align-items: center;
      justify-content: space-between;
      //padding-right: 29px;
      ul {
        display: flex;
        margin-bottom: 10px;

        li {
          cursor: pointer;
          padding: 10px 0;
          color: #b8b8b8;
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: bold;

          &:nth-of-type(1) {
            margin-right: 20px;
          }
        }

        .active {
          position: relative;
          color: #343434;

          &::after {
            position: absolute;
            bottom: 0;
            left: 0;
            display: inline-block;
            content: "";
            width: 100%;
            height: 4px;
            background: #ff7402;
          }
        }
      }

      span {
        cursor: pointer;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #9a9a9a;
      }
    }

    .curriculum_list {
      display: flex;
      flex-wrap: wrap;

      li{
        // flex: 1;
        position: relative;
        cursor: pointer;
        //width: 31%;
        width: 23%;
        //margin-right: 12px;
        margin-right: 28px;
        margin-bottom: 20px;
        span{
          color: rgba(153, 153, 153, 1);
        }
        &:nth-of-type(4n) {
          margin-right: 0;
        }
        .courseList{
          display: none;
        }
        &.active{
          margin-top: -14px;
          .img{
            display: none;
          }
          .model{
            display: none;
          }
          .curriculum_title{
            display: none;
          }
          .curriculum_time{
            display: none;
          }
          .courseList{
            width: 100%;
            display: block;
            height: 98px;
            padding: 25px 15px;
            border: 1px solid rgba(238, 238, 238, 1);
            img{
              width: 37px;
              height: 45px;
              display: block;
              float: left;
            }
            .courseList_box{
              width: 135px;
              overflow: hidden;
              float: right;
              height: 55px;
              p{
                font-size: 14px;
                height:38px;
                overflow: hidden;
                display:-webkit-box;
                -webkit-box-orient:vertical;
                -webkit-line-clamp:2;
              }
            }
          }
        }
        .img {
          width: 100%;
          height: 171px;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
            transition: all 0.5s;
            &:hover {
              transform: scale(1.2);
            }
          }
        }

        .model {
          position: absolute;
          width: 50px;
          height: 50px;
          background: url("../assets/images/play.png") no-repeat center/100%;
          top: 25%;
          right: 40%;
        }
        .curriculum_title {
          margin: 5px 0;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #343434;

          // 单行溢出省略
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .curriculum_time {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #9a9a9a;
        }
      }
    }
  }

  .expert {
    flex: 3;
    //  width: 27%;
    .export_meun {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 0;
      margin-bottom: 10px;

      p {
        color: #343434;
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: bold;

        &::before {
          display: inline-block;
          width: 5px;
          height: 23px;
          content: "";
          background: #ff7402;
          vertical-align: middle;
          margin-right: 5px;
        }
      }

      span {
        cursor: pointer;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #9a9a9a;
      }
    }

    .button-prev,
    .button-next {
      width: 100%;
      line-height: 20px;
      text-align: center;
      background: linear-gradient(-79deg, #ff7602, #ffc602);
      cursor: pointer;
    }

    .swiper-wrapper {
      .box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        img {
          // height: 80px;
          width: 100%;
        }

        .export_desc {
          margin-left: 10px;
          width: 100%;
          p {
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333;
            margin-bottom: 5px;
          }
          div{
            font-size: 14px;
            color: #999;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
			width: 98%;
			text-overflow: ellipsis;
          }
        }
      }
    }
  }
}

.database {
  width: 100%;
  margin-bottom: 40px;
  margin-top: 60px;
  .database_nav {
    height: 62px;
    background: url("../assets/images/bg_8.jpg") no-repeat center/cover;
    padding: 0 30px;
    display: flex;
    align-items: center;

    span {
      flex: 1;

      &:nth-of-type(1) {
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #ffffff;
      }

      &:nth-of-type(2) {
        cursor: pointer;
        text-align: right;
        font-size: 14px;
        // font-size: 13px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
      }
    }

    ul {
      flex: 8;
      display: flex;

      li {
        cursor: pointer;
        // font-size: 14px;
        font-size: 13px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        margin-right: 24px;

        &:last-of-type {
          margin-right: 0;
        }
      }

      .active {
        position: relative;

        &::after {
          position: absolute;
          bottom: -10px;
          left: 0;
          display: inline-block;
          content: "";
          width: 100%;
          height: 2px;
          background: #ffffff;
        }
      }
    }
  }

  .database_list {
    width: 100%;
    border: 1px solid #eeeeee;
    height: 210px;
    display: flex;
    align-content: flex-star;
    position: relative;
    &:before{
      content: '';
      width: 355px;
      height: 100%;
      background: rgba(245, 248, 251, 1);
      position: absolute;
      left: 33.5%;
      display: block;
      top: 0;
      z-index: -1;
    }
    ul {
      padding: 10px 15px;
      width: 33%;
      position: relative;
      height: 202px;
      li {
        width: 100%;
        cursor: pointer;
        display: block;
        float: left;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        height: 14px;
        margin: 12px 5px 12px 0;

        &:hover {
          p,
          span {
            color: #ff8a02;
          }
        }
        p {
          max-width: 193px;
          color: #666666;
          margin-right: 10px;
          display: block;
          float: left;

          // 单行溢出省略
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        span {
          color: #9a9a9a;
          float: right;
          display: block;
        }
      }

      // .active {
      //   color: #ff8a02;
      // }
    }

  }
}

.enterprises_list {
  margin-bottom: 40px;
 .swiper-slide:nth-child(n){
   div:last-child{
     background: #EEEEEE;
   }
 }
  .swiper-slide:nth-child(2n){
    div:first-child{
      background: #EEEEEE;
    }
  }
  p {
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #343434;
    margin-bottom: 20px;

    &::before {
      display: inline-block;
      width: 5px;
      height: 23px;
      content: "";
      background: #ff7402;
      vertical-align: middle;
      margin-right: 5px;
    }
  }
  .swiper-list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .button-prev,
    .button-next {
      cursor: pointer;
      // position: absolute;
      // top: 25%;
      z-index: 999;
    }
    .button-next {
      // right: 0;
    }
    .swiper-container {
      .box {
        text-align: center;
        img {
          width: 100%;
        }
      }
    }
  }

  ul {
    display: flex;
    align-items: center;

    &:nth-of-type(2) {
      margin-top: -5px;
    }

    li {
      flex: 1;

      img {
        width: 100%;
      }
    }
  }
}

.product_recommendation {
  .product_tips {
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #343434;
    margin-bottom: 20px;

    &::before {
      display: inline-block;
      width: 5px;
      height: 23px;
      content: "";
      background: #ff7402;
      vertical-align: middle;
      margin-right: 5px;
    }
  }

  ul {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    li {
      position: relative;
      cursor: pointer;
      width: 24%;
      border: 1px solid #eeeeee;
      // margin-right: 14px;
      margin-bottom: 14px;

      &:nth-of-type(4n) {
        margin-right: 0;
      }

      .img {
        width: 100%;
        height: 174px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          transition: all 0.5s;
          &:hover {
            transform: scale(1.2);
          }
        }
      }

      .product_info {
        display: flex;
        flex-direction: column;
        padding: 10px;
        .product_message {
          width: 100%;
          p {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #343434;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          span {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #9a9a9a;
          }
        }

        .product_price {
          font-size: 16px;
          font-family: Arial;
          font-weight: 400;
          color: #ff3600;
          text-align: left;
          // position: absolute;
          // right: 10px;
          bottom: 5px;
        }
      }
    }
  }
}

.info_needs {
  display: flex;
  justify-content: space-between;
  line-height: 62px;
  margin-bottom: 40px;
  margin-top: 40px;

  .supply_info {
    // flex: 7;
    width: 70%;
    height: 100%;

    .supply_tips {
      padding-left: 10px;
      background: url("../assets/images/bg_9.jpg") no-repeat center/cover;
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #ffffff;
      display: flex;
      justify-content: space-between;
    }
    .supply_tips span:nth-child(2){
       font-size: 14px;
       cursor: pointer;
       margin-right: 20px;
    }


    .supply_list {
      display: flex;
      justify-content: space-between;
      border: 1px solid #eeeeee;

      ul {
        width: 50%;
        padding: 5px 15px;

        &:nth-of-type(1) {
          position: relative;

          &::after {
            position: absolute;
            top: 34px;
            right: 0;
            display: inline-block;
            content: "";
            width: 1px;
            height: 94px;
            background: #9a9a9a;
            opacity: 0.2;
          }
        }

        li {
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #666666;
          line-height: 30px;
          margin-bottom: 10px;
          &:last-of-type {
            margin-bottom: 0;
          }
          &:hover {
            p,
            span {
              color: #ff8a02;
            }
          }
          p {
            max-width: 193px;
            color: #666666;
            margin-right: 10px;
            // 单行溢出省略
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          span {
            color: #9a9a9a;
          }
        }

        // .active {
        //   color: #ff8a02;
        // }
      }
    }
  }

  .environment_nedds {
    // flex: 3;
    width: 30%;
    height: 100%;
    margin-left: 16px;

    .environment_tips {
      padding-left: 10px;
      background: url("../assets/images/bg_10.jpg") no-repeat center/cover;
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      display: flex;
      justify-content: space-between;
      color: #ffffff;
    }
    .environment_tips span:nth-child(2){
      font-size: 14px;
      cursor: pointer;
      margin-right: 20px;
    }
    .environment_list {
      display: flex;
      justify-content: space-between;
      border: 1px solid #eeeeee;

      ul {
        // flex: 1;
        width: 100%;
        padding: 5px 15px;

        li {
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #666666;
          line-height: 30px;
          margin-bottom: 10px;
          &:last-of-type {
            margin-bottom: 0;
          }
          &:hover {
            p,
            span {
              color: #ff8a02;
            }
          }
          p {
            max-width: 193px;
            color: #666666;
            margin-right: 10px;
            // 单行溢出省略
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          span {
            color: #9a9a9a;
          }
        }

        // .active {
        //   color: #ff8a02;
        // }
      }
    }
  }
}
.swiper_bater img {
  width: 100%;
}
.swiper_bater{
  width: 134px;
  height: 90px;
  border-radius: 100%;
  overflow: hidden;
}


 .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 150px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
     background-color: #99a9bf;
  }
  
  .el-carousel__item:nth-child(2n+1) {
     background-color: #d3dce6;
  }
   .ulClass {
    li {
      cursor: pointer;
      margin: 10px 0;
      border-bottom: 1px solid #eeeeee;
      padding-bottom: 10px;
      &:last-of-type {
        border-bottom: 0;
      }
      &:hover {
        .news_title{
          color: #ff8a02;

        }
        .news_desc{
          color: #ff8a02;
        }
      }
      .news_title {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        // 单行溢出省略
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .news_title_first {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        // 单行溢出省略
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-weight: bold;
      }
      .news_desc {
        line-height: 24px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        // 多行溢出省略
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        margin-top: 1px;
        max-height: 48px;
        height: 48px;
      }
    }
  }
/deep/.el-tabs__item {
    padding: 0 20px;
    height: 40px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    line-height: 40px;
    display: inline-block;
    list-style: none;
    font-size: 18px !important;
    font-weight: 500;
    color: #303133;
    position: relative;
    font-weight: bold;
}
.imgBack{
  position: absolute;
  bottom: 12px;
  height: 50px;
  overflow: hidden;
  color: #ffffff;
  white-space: nowrap;
  display: block;
  text-overflow: ellipsis;
  width: 376px;
  line-height: 50px;
  background: rgba(0,0,0,0.1);
}
.false {
  cursor: pointer;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #9a9a9a;
  &::before {
    display: inline-block;
    content: "";
    width: 17px;
    height: 17px;
    background: url("../assets/images/break.png") no-repeat
      center/100%;
    vertical-align: bottom;
    margin-right: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/index.vue